import {DesignServiceModel} from "../../../../models/domain/designServiceModel";
import * as React from "react";

/**
 * The AddToCartDesignServicesContent component is used to display the design services options for a product.
 * @param price The product price of the design services.
 * @constructor
 */
export const AddToCartDesignServicesContent = ({model: {formatted: {price}}}: { model: DesignServiceModel }) => {
    return (
        <div>
            <strong className="fw-bold d-block">Design Services</strong>
            <small className="text-muted">
                Expect your dedicated design team to contact you within 24 hours to bring your vision to life starting
                with 1-hour of design services. About Design Services
            </small>
        </div>
    )
};